import React from "react";

// const SearchBar = ({ className = "" }) => (
//   <div className={`relative ${className}`}>
//     <input
//       type="text"
//       className="h-12 w-full rounded-lg border border-gray-200 bg-white/80 pl-4 pr-12 placeholder-gray-500 backdrop-blur-sm transition-all duration-200 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-blue-500"
//       placeholder="Search trends, creators, or brands..."
//     />
//     <div className="absolute right-3 top-1/2 -translate-y-1/2 transform">
//       <svg
//         className="h-5 w-5 cursor-pointer text-gray-600 transition-colors hover:text-blue-500"
//         fill="none"
//         stroke="currentColor"
//         viewBox="0 0 24 24"
//       >
//         <path
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           strokeWidth="2"
//           d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
//         />
//       </svg>
//     </div>
//   </div>
// );

function SocialGlaasHeader() {
  return (
    <header className="flex w-full flex-col items-center justify-between gap-2 border border-[#E5E7EB] p-4 sm:h-[74px] sm:flex-row">
      <img src="/Ambasscologo.svg" alt="Ambascoo logo" className="h-12 w-auto" />

      {/* Search Bar (Desktop only) */}
      {/* <SearchBar className="hidden sm:block sm:w-[672px]" /> */}

      <div className="flex items-center justify-between gap-2">
        <img
          src="/PFPplaceholder.svg"
          alt="user profile image"
          className="h-12 w-auto"
        />
      </div>
    </header>
  );
}

export default SocialGlaasHeader;
